import { render, staticRenderFns } from "./OngoingShipmentsStats.vue?vue&type=template&id=3278eeaf&scoped=true&"
import script from "./OngoingShipmentsStats.vue?vue&type=script&lang=js&"
export * from "./OngoingShipmentsStats.vue?vue&type=script&lang=js&"
import style0 from "./OngoingShipmentsStats.vue?vue&type=style&index=0&id=3278eeaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3278eeaf",
  null
  
)

export default component.exports